import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom"
import { showToast, ToastMessage } from "../../Shared/ToastMessage"
import { useUser } from "../../AdminUsers/UserContext"
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import {
  FaUsers,
  FaUserCheck,
  FaTicketAlt,
  FaShoppingCart,
  FaPuzzlePiece,
  FaChevronRight,
  FaDownload,
  FaChartBar,
  FaSpinner,
} from "react-icons/fa"
import axios from "axios"
import { localserver } from "../../../api/common"

const Reports = () => {

  const { checkPermission } = useUser()
  const [eventCountList, setEventCountList] = useState({})

  function convertDBDate(dateStr) {
    if (!dateStr) return "N/A";

    const date = new Date(dateStr);

    return new Intl.DateTimeFormat("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      timeZone: "UTC"
    }).format(date);
  }

  // Check Admin User Permission
  const [checkUserLoading, setCheckUserLoading] = useState(false)
  const fetchPermission = async () => {
    setCheckUserLoading(true)
    try {
      const hasPermission = await checkPermission("Reports", "view")
      if (!hasPermission) return
    } catch (error) {
      console.error("Error Check Permission:", error)
    } finally {
      setCheckUserLoading(false)
    }
  }
  useEffect(() => {
    fetchPermission()
  }, [])

  const [attendeesExportToExcelStatus, setAttendeesExportToExcelStatus] = useState(false);
  const attendeesExportToExcel = async(
    // id = selectedApplicationId,
    status = "confirmed",
    // limitValue = rowsPerPage,
    // limitoffset = currentPage,
    // searchTerm = searchQuery,
    // from_date = startDate,
    // to_date = endDate
  ) => {
    setAttendeesExportToExcelStatus(true);
    // showToast("Downloading Attendees report...", "info")
    try {
      const response = await axios.post(
        `${localserver}/attendee_by_event_id`,
        {
          event_id: localStorage.getItem("eventId"),
          status,
          // ...(ticket_id !== "0" && { ticket_id }),
          // from_date,
          // to_date,
          // search,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        },
      )
      if (response.data.success) {
        console.log(response.data.attendees,"Report Data");
        if( response.data.attendees.length>0){
          // Collect all unique custom field labels across attendees for consistent columns, excluding basics
          const allFields = new Set();
          const excludedFields = ['First Name', 'Last Name', 'Email Address'];
          response.data.attendees.forEach(attendee => {
            try {
              const formData = JSON.parse(attendee.form_data || '[]');
              if (formData && formData.length > 0 && formData[0].custom_fields) {
                formData[0].custom_fields.forEach(field => {
                  const label = field.label;
                  if (label && !excludedFields.includes(label)) {
                    allFields.add(label);
                  }
                });
              }
            } catch (e) {
              console.error("Error parsing form_data:", e);
            }
          });
          // Do NOT add 'Name' or 'Email' to allFields; they will be explicit
  
          const processedData = response.data.attendees
            .filter((data) => (data.email !== "" && data.email !== null))
            .map((data, index) => {
              let fieldValues = {};
              try {
                const formData = JSON.parse(data.form_data || '[]');
                if (formData && formData.length > 0 && formData[0].custom_fields) {
                  formData[0].custom_fields.forEach(field => {
                    const label = field.label;
                    if (label && field.value !== undefined && field.value !== null) {
                      fieldValues[label] = field.value;
                    }
                  });
                }
              } catch (e) {
                console.error("Error parsing form_data:", e);
              }
  
              // Add concatenated Name from custom fields
              const firstName = fieldValues['First Name'] || '';
              const lastName = fieldValues['Last Name'] || '';
              fieldValues['Name'] = (firstName || lastName)
                ? `${firstName} ${lastName}`.trim().replace(/\s+/g, " ")
                : 'N/A';
  
              // Add Email, preferring form_data value
              fieldValues['Email'] = fieldValues['Email Address'] || data.email || 'N/A';
  
              return {
                'S.No': index + 1,
                'Registered On': convertDBDate(data.created_at) || 'N/A',
                'Registered ID': data.id || 'N/A',
                'Name': fieldValues['Name'],
                'Email': fieldValues['Email'],
                'Ticket Name': data.ticket_name || 'N/A',
                Status: data.status || 'N/A',
                // Dynamically add all custom fields as columns using labels as headers (excludes Name, Email, and basics)
                ...Object.fromEntries(
                  Array.from(allFields).map(field => [field, fieldValues[field] || 'N/A'])
                )
              }
            });
        
          const ws = XLSX.utils.json_to_sheet(processedData);
          const csv = XLSX.utils.sheet_to_csv(ws);
          const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
          saveAs(blob, 'Event-Attendees-Report.csv');
          showToast("Attendees report Downloaded", "success")
        }else{
          showToast(response.data.message, "error")
        }
       }
      } catch (error) {
        console.error("Error fetching event data:", error)
      } finally {
        setAttendeesExportToExcelStatus(false);
      }
    };


  const [ordersExportToExcelStatus, setOrdersExportToExcelStatus] = useState(false);
  const ordersExportToExcel = async(
    // id = selectedApplicationId,
    status = "all",
    // limitValue = rowsPerPage,
    // limitoffset = currentPage,
    // searchTerm = searchQuery,
    // from_date = startDate,
    // to_date = endDate
  ) => {
    setOrdersExportToExcelStatus(true);
    // showToast("Downloading Orders report...", "info")
    try {
      const response = await axios.post(
        `${localserver}/getOrderByEventId`,
        {
          event_id: localStorage.getItem("eventId"),
          status,
          // ...(ticket_id !== "0" && { ticket_id }),
          // from_date,
          // to_date,
          // search,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        },
      )
      if (response.data.success) {
        console.log(response.data.attendees,"Report Data");
        if( response.data.attendees.length > 0){
          // Collect all unique custom field labels across orders for consistent columns, excluding basics
          const allFields = new Set();
          const excludedFields = ['First Name', 'Last Name', 'Email Address'];
          response.data.attendees.forEach(order => {
            try {
              const formData = JSON.parse(order.form_data || '[]');
              if (formData && formData.length > 0 && formData[0].custom_fields) {
                formData[0].custom_fields.forEach(field => {
                  const label = field.label;
                  if (label && !excludedFields.includes(label)) {
                    allFields.add(label);
                  }
                });
              }
            } catch (e) {
              console.error("Error parsing form_data:", e);
            }
          });
          // Do NOT add 'Name' or 'Email' to allFields; they will be explicit
  
          const processedData = response.data.attendees
            .filter((data) => (data.email !== "" && data.email !== null && data.status!=="pending"))
            .map((data, index) => {
              let fieldValues = {};
              try {
                const formData = JSON.parse(data.form_data || '[]');
                if (formData && formData.length > 0 && formData[0].custom_fields) {
                  formData[0].custom_fields.forEach(field => {
                    const label = field.label;
                    if (label && field.value !== undefined && field.value !== null) {
                      fieldValues[label] = field.value;
                    }
                  });
                }
              } catch (e) {
                console.error("Error parsing form_data:", e);
              }
  
              // Add concatenated Name from custom fields
              const firstName = fieldValues['First Name'] || '';
              const lastName = fieldValues['Last Name'] || '';
              fieldValues['Name'] = (firstName || lastName)
                ? `${firstName} ${lastName}`.trim().replace(/\s+/g, " ")
                : 'N/A';
  
              // Add Email, preferring form_data value
              fieldValues['Email'] = fieldValues['Email Address'] || data.email || 'N/A';
  
              return {
                'S.No': index + 1,
                'Order Date': convertDBDate(data.created_at) || 'N/A',
                'Order ID': data.id || 'N/A',
                'Name': fieldValues['Name'],
                'Email': fieldValues['Email'],
                'Ticket Name': data.ticket_name || 'N/A',
                'Payment Status': data.payment_status || 'N/A',
                'Payment Method': data.payment_method || 'N/A',
                'Total Amount': data.total_amount || 'N/A',
                'Currency': data.currency || 'N/A',
                // 'Order Status': data.order_status || 'N/A',
                'Status': data.status || 'N/A',
                // Dynamically add all custom fields as columns using labels as headers (excludes Name, Email, and basics)
                ...Object.fromEntries(
                  Array.from(allFields).map(field => [field, fieldValues[field] || 'N/A'])
                )
              }
            });
        
          const ws = XLSX.utils.json_to_sheet(processedData);
          const csv = XLSX.utils.sheet_to_csv(ws);
          const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
          saveAs(blob, 'Event-Orders-Report.csv');
          showToast("Orders report Downloaded", "success")
        }else{
          showToast(response.data.message, "error")
        }
       }
      } catch (error) {
        console.error("Error fetching event data:", error)
      } finally {
        setOrdersExportToExcelStatus(false);
      }
    };

  const reportCards = [
    {
      id: 1,
      title: "Attendees",
      description: "A detailed report on your attendee data. Includes data collected during checkout.",
      icon: FaUsers,
      iconBg: "#3b82f6",
      type: "attendees",
    },
    {
      id: 2,
      title: "Orders",
      description: "Data on all buyers including a cost breakdown of each order",
      icon: FaShoppingCart,
      iconBg: "#059669",
      type: "orders",
    }
  ]

  return (
    <>
      <ToastMessage />
      {checkUserLoading ? (
        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "500px" }}>
          <div className="spinner-border text-primary" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        </div>
      ) : (
        <div className="container-fluid" style={{ padding: "24px", backgroundColor: "#f9fafb" }}>        
          <div style={{ marginBottom: "22px" }}>
            <div className="brood_comes_div">
              <div className="row align-items-center">
                <div className="col-md-6 brood_comes_heading">
                  <h2  >
                    <div className="brood_comes_part">
                      <FaChartBar />
                    </div>
                    Reports
                  </h2>
                  {/* Enhanced Breadcrumb */}
                  {/* <nav aria-label="breadcrumb">
                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                      <Link
                        to="/events/admin/"
                        style={{
                          color: "#6b7280",
                          textDecoration: "none",
                          fontSize: "14px",
                          transition: "color 0.2s ease",
                        }}
                        onMouseEnter={(e) => (e.target.style.color = "#184778")}
                        onMouseLeave={(e) => (e.target.style.color = "#6b7280")}
                      >
                        AMASI
                      </Link>
                      <FaChevronRight size={10} style={{ color: "#d1d5db" }} />
                      <span style={{ color: "#184778", fontSize: "14px", fontWeight: "500" }}>Orders & Payments</span>
                    </div>
                  </nav> */}
                </div>
              </div>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "16px",
            }}
          >
            {reportCards.map((report) => {
              const IconComponent = report.icon
              const isLoading = report.type === "attendees" ? attendeesExportToExcelStatus : ordersExportToExcelStatus;
              return (
                <div
                  key={report.id}
                  style={{
                    backgroundColor: "#ffffff",
                    borderRadius: "12px",
                    padding: "24px",
                    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
                    border: "1px solid #e5e7eb",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: "20px",
                    transition: "all 0.2s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.boxShadow = "0 4px 12px rgba(0, 0, 0, 0.15)"
                    e.currentTarget.style.transform = "translateY(-2px)"
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.boxShadow = "0 1px 3px rgba(0, 0, 0, 0.1)"
                    e.currentTarget.style.transform = "translateY(0)"
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center", gap: "20px", flex: 1 }}>
                    <div
                      style={{
                        width: "48px",
                        height: "48px",
                        backgroundColor: report.iconBg,
                        borderRadius: "50%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "white",
                        flexShrink: 0,
                      }}
                    >
                      <IconComponent size={24} />
                    </div>
                    <div>
                      <h3
                        style={{
                          fontSize: "16px",
                          fontWeight: "600",
                          color: "#111827",
                          margin: "0 0 4px 0",
                        }}
                      >
                        {report.title}
                      </h3>
                      <p
                        style={{
                          fontSize: "14px",
                          color: "#6b7280",
                          margin: 0,
                          lineHeight: "1.5",
                        }}
                      >
                        {report.description}
                      </p>
                    </div>
                  </div>
                  <button
                    disabled={isLoading}
                    onClick={() => {
                      if (report.type === "attendees") {
                        attendeesExportToExcel();
                      } else if (report.type === "orders") {
                        ordersExportToExcel();
                      }
                    }}
                    style={{
                      padding: "10px 24px",
                      backgroundColor: "#ffffff",
                      color: "#184778",
                      border: "1px solid #e5e7eb",
                      borderRadius: "8px",
                      fontSize: "14px",
                      fontWeight: "500",
                      cursor: isLoading ? "not-allowed" : "pointer",
                      transition: "all 0.2s ease",
                      whiteSpace: "nowrap",
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                    onMouseEnter={(e) => {
                      if (!isLoading) {
                        e.currentTarget.style.backgroundColor = "#184778"
                        e.currentTarget.style.color = "#ffffff"
                        e.currentTarget.style.borderColor = "#184778"
                      }
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = "#ffffff"
                      e.currentTarget.style.color = "#184778"
                      e.currentTarget.style.borderColor = "#e5e7eb"
                    }}
                  >
                    {isLoading ? (
                      <>
                        <FaSpinner className="fa-spin" style={{ fontSize: "14px" }} />
                        Downloading...
                      </>
                    ) : (
                      <>
                        <FaDownload size={14} />
                        Download
                      </>
                    )}
                  </button>
                </div>
              )
            })}
          </div>
        </div>
      )}
    </>
  )
}

export default Reports